var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div-unit',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.checkRateTrendData),expression:"checkRateTrendData"}],attrs:{"unitTitle":"Dynamic ClinSR for","customHTML":_vm.dis_value_show,"unitTitle2":`based on ${_vm.xxx[_vm.calMethod]}`}},[_c('SuccessRateHomeNew',{attrs:{"plotRateTrendData":_vm.graph,"calMethod":_vm.calMethod}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }